/**
 * @file OrganizationDetailAboutExtraInfoSlot.tsx
 *
 * @fileOverview A slot component for displaying extra information in the About section of the organization profile detail.
 */

import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { OrganizationProfile } from '~/jobiqo/types/types';

interface OrganizationDetailAboutExtraInfoSlotProps {
  /**
   * The organization profile entity.
   */
  organization: Slottable<OrganizationProfile>;
}

export default function OrganizationDetailAboutExtraInfoSlot({
  organization,
}: OrganizationDetailAboutExtraInfoSlotProps) {
  return null;
}
export { OrganizationDetailAboutExtraInfoSlot };
